import { useQuery } from 'react-query'
import ManagementService from '../coreApi'
import { IUserDetail } from '../types/feed'
import useUserId from './useUserId'

const useUserDetail = () => {
  const userId = useUserId()
  return useQuery<IUserDetail, Error>(
    ['userDetail', userId],
    () => ManagementService.getUserDetail(userId),
    {
      enabled: !!userId,
    },
  )
}

export default useUserDetail
